// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopTokenizationTestControllerGetTestTokenizationResultData } from './EshopTokenizationTestControllerGetTestTokenizationResultData.gen';
import type { EshopTokenizationTestControllerGetTestTokenizationResultErrors } from './EshopTokenizationTestControllerGetTestTokenizationResultErrors.gen';
import type { EshopTokenizationTestControllerGetTestTokenizationResultResponses } from './EshopTokenizationTestControllerGetTestTokenizationResultResponses.gen';
import type { EshopTokenizationTestControllerInitTestTokenizationData } from './EshopTokenizationTestControllerInitTestTokenizationData.gen';
import type { EshopTokenizationTestControllerInitTestTokenizationErrors } from './EshopTokenizationTestControllerInitTestTokenizationErrors.gen';
import type { EshopTokenizationTestControllerInitTestTokenizationResponses } from './EshopTokenizationTestControllerInitTestTokenizationResponses.gen';
import type { Options } from './Options.gen';

export class EshopTokenizationTestController {
    /**
     * TEST - Zahájení tokenizace přes MONET+ bránu.
     *
     * Vytvoří registrační žádost a vrátí URL brány. Otevři gtwUrl v prohlížeči, zadej číslo karty a po dokončení zavolej GET /result/{regId}.
     */
    public static initTestTokenization<ThrowOnError extends boolean = false>(options?: Options<EshopTokenizationTestControllerInitTestTokenizationData, ThrowOnError>) {
        return (options?.client ?? client).post<EshopTokenizationTestControllerInitTestTokenizationResponses, EshopTokenizationTestControllerInitTestTokenizationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/test/tokenization/init',
            ...options
        });
    }
    
    /**
     * TEST - Získání výsledku tokenizace z MONET+ brány.
     *
     * Vrátí aktuální stav registrační žádosti včetně tokenu pokud tokenizace proběhla úspěšně. Token porovnej s výsledkem SAM modulu.
     */
    public static getTestTokenizationResult<ThrowOnError extends boolean = false>(options: Options<EshopTokenizationTestControllerGetTestTokenizationResultData, ThrowOnError>) {
        return (options.client ?? client).get<EshopTokenizationTestControllerGetTestTokenizationResultResponses, EshopTokenizationTestControllerGetTestTokenizationResultErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/test/tokenization/result/{regId}',
            ...options
        });
    }
}
